import { inject, Injectable } from '@angular/core';
import { MatStepperIntl } from '@angular/material/stepper';

import { TranslationStore } from '../state/translation.store';

@Injectable()
export class StepperIntl extends MatStepperIntl {
  private translationStore = inject(TranslationStore);
  
  override optionalLabel = this.translationStore.translate('COMMON.LABELS.OPTIONAL');
}
